module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/doctors/sp/icon_noimage-e82e7a4b9b4d91c567d0e33998116be2.png";